/* Lightweight toast used by admin components outside the main Dashboard.
   Mirrors the inline CustomToast in Dashboard.tsx so new components can
   show the same styled toasts without importing from Dashboard. */
export const CustomToast = {
  show: (message: string, type: 'success' | 'error' | 'info' | 'warning' = 'info') => {
    const toast = document.createElement('div');
    toast.className = `custom-toast ${type}`;
    toast.textContent = message;
    toast.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? '#43BE83' : type === 'error' ? '#EA8F95' : type === 'warning' ? '#FFA726' : '#5041BC'};
      color: #fff;
      padding: 12px 18px;
      border-radius: 10px;
      font-size: 14px;
      font-weight: 600;
      box-shadow: 0 8px 24px rgba(0,0,0,0.18);
      z-index: 100000;
      max-width: 360px;
    `;
    document.body.appendChild(toast);
    setTimeout(() => { toast.remove(); }, 3200);
  },
};
